
import { computed, defineComponent, PropType, Ref, ref, watch } from "vue";
export default defineComponent({
  name: "controlMapElements",
  props: {
    showErected: {
      type: Boolean as PropType<boolean>,
      required: true,
      defualt: false,
    },
  },
  emits: [
    "toggle-virtualWalls",
    "toggle-paths",
    "toggle-functionAreas",
    "toggle-functionpoints",
  ],
  setup(props, context) {
    const mShowErected = computed<boolean>(() => props.showErected);
    const showvirtualwall = ref<boolean>(false);
    const showpath = ref<boolean>(false);
    const showfunctionAreas = ref<boolean>(false);
    const showfunctionpoints = ref<boolean>(false);

    let cusWall = ref<boolean>(false);
    let cusPath = ref<boolean>(false);
    let cusAreas = ref<boolean>(false);
    let cusPoints = ref<boolean>(false);

    const cusWallEnable = ref<boolean>(true);
    const cusPathEnable = ref<boolean>(true);
    const cusAreasEnable = ref<boolean>(true);
    const cusPointsEnable = ref<boolean>(true);

    const toggleVirtualWallsMethods = () => {
      cusWall.value = showvirtualwall.value = !showvirtualwall.value;
      context.emit("toggle-virtualWalls", showvirtualwall.value);
    };
    const togglePathsMethods = () => {
      cusPath.value = showpath.value = !showpath.value;
      context.emit("toggle-paths", showpath.value);
    };
    const toggleFunctionAreasMethods = () => {
      cusAreas.value = showfunctionAreas.value = !showfunctionAreas.value;
      context.emit("toggle-functionAreas", showfunctionAreas.value);
    };
    const toggleFunctionpointsMethods = () => {
      cusPoints.value = showfunctionpoints.value = !showfunctionpoints.value;
      context.emit("toggle-functionpoints", showfunctionpoints.value);
    };
    const setDefaultF = () => {
      context.emit("toggle-virtualWalls", showvirtualwall.value);
      context.emit("toggle-paths", showpath.value);
      context.emit("toggle-functionAreas", showfunctionAreas.value);
      context.emit("toggle-functionpoints", showfunctionpoints.value);
    };

    const setDefaultShow = (
      path: Ref<boolean>,
      wall: Ref<boolean>,
      area: Ref<boolean>,
      point: Ref<boolean>
    ) => {
      cusWall = wall;
      cusPath = path;
      cusAreas = area;
      cusPoints = point;
      showvirtualwall.value = cusWall.value;
      showpath.value = cusPath.value;
      showfunctionAreas.value = cusAreas.value;
      showfunctionpoints.value = cusPoints.value;
    };

    const setDefaultEnable = (
      path: boolean,
      wall: boolean,
      area: boolean,
      point: boolean
    ) => {
      cusWallEnable.value = wall;
      cusPathEnable.value = path;
      cusAreasEnable.value = area;
      cusPointsEnable.value = point;
    };

    setDefaultF();

    return {
      showvirtualwall,
      showpath,
      showfunctionAreas,
      showfunctionpoints,
      toggleVirtualWallsMethods,
      togglePathsMethods,
      toggleFunctionAreasMethods,
      toggleFunctionpointsMethods,
      setDefaultShow,
      setDefaultEnable,
      cusWallEnable,
      cusPathEnable,
      cusAreasEnable,
      cusPointsEnable,
      mShowErected,
    };
  },
});
